<template>
  <v-dialog :modelValue="dialog" @click:outside="$emit('close')" @keydown.esc="$emit('close')" max-width="1100px" transition="dialog-bottom-transition">
    <v-card>
      <v-form>
        <v-card-title>
          <span class="headline">Agregar ubicación al conteo</span>
        </v-card-title>

        <v-card-text>
          <v-card class="mb-4">
            <div class="row mb-2 ps-3 pe-3 mt-0 mb-2">
              <div class="col-md-12">
                <div class="col-md-12" style="background: white">
                  <p class="text-h6 mt-2 mb-0"><font-awesome-icon icon="filter" class="pr-2" />Filtros</p>
                  <v-divider class="mt-0"></v-divider>
                  <div class="row pt-2">
                    <div class="col-md-3">
                      <v-combobox
                        density="comfortable"
                        v-model="filters.almacen"
                        item-title="label"
                        item-value="id"
                        :items="almacenes"
                        label="Almacen"
                        autocomplete="off"
                        clearable
                        :loading="loading_almacenes"
                        :disabled="almacen != null"
                        :hint="almacen != null ? 'Fijado por el almacén del conteo' : ''"
                        persistent-hint
                        @update:modelValue="loadZonas"
                      ></v-combobox>
                    </div>
                    <div class="col-md-3">
                      <v-combobox
                        density="comfortable"
                        v-model="filters.zona"
                        item-title="label"
                        item-value="id"
                        :items="zonas"
                        label="Zona"
                        autocomplete="off"
                        clearable
                        :loading="loading_zonas"
                      ></v-combobox>
                    </div>
                    <div class="col-md-3">
                      <v-combobox density="comfortable" v-model="filters.status" item-title="name" item-value="id" :items="states" label="Estado" autocomplete="off" clearable></v-combobox>
                    </div>
                    <div class="col-md-3">
                      <v-text-field v-model="filters.code" density="comfortable" label="Codigo" @keyup.enter="filter"></v-text-field>
                    </div>
                    <div class="col-md-3">
                      <v-text-field v-model="filters.rack" density="comfortable" label="Rack" @keyup.enter="filter"></v-text-field>
                    </div>
                    <div class="col-md-3">
                      <v-text-field v-model="filters.col" density="comfortable" label="Columna" @keyup.enter="filter"></v-text-field>
                    </div>
                    <div class="col-md-3">
                      <v-text-field v-model="filters.level" density="comfortable" label="Nivel" @keyup.enter="filter"></v-text-field>
                    </div>
                    <div class="col-md-3 mt-2 mb-2" style="display: flex; justify-content: end">
                      <v-btn color="info" @click="filter" prepend-icon="mdi-magnify">Buscar</v-btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-card>

          <!-- El mensaje del backend viaja tal cual: es mas util que un texto generico -->
          <v-alert v-if="error" type="warning" variant="tonal" density="compact" class="mb-3">
            {{ error }}
          </v-alert>

          <v-data-table :headers="headers" :items="available_list" :loading="loading" loading-text="Cargando..." :items-per-page="10" no-data-text="No hay ubicaciones para esos filtros">
            <template v-slot:headers>
              <tr>
                <th class="text-center" style="width: 48px">
                  <v-checkbox
                    :model-value="all_selected"
                    :indeterminate="some_selected && !all_selected"
                    :disabled="seleccionables.length == 0"
                    hide-details
                    density="compact"
                    @update:model-value="toggleAll"
                  ></v-checkbox>
                </th>
                <th class="text-left">Almacen</th>
                <th class="text-left">Zona</th>
                <th class="text-left">Tipo</th>
                <th class="text-left">Codigo</th>
                <th class="text-left">Rack</th>
                <th class="text-left">Columna</th>
                <th class="text-left">Nivel</th>
                <th class="text-left">Estado</th>
                <th class="text-left"></th>
              </tr>
            </template>
            <template v-slot:item="{ item }">
              <tr :class="{ 'bg-grey-lighten-4': !item.seleccionable }">
                <td class="text-center">
                  <!-- Una ubicacion ya tomada por otro conteo abierto no se puede elegir -->
                  <v-checkbox v-model="selected" :value="item.id" :disabled="!item.seleccionable" hide-details density="compact"></v-checkbox>
                </td>
                <td>{{ item.zona && item.zona.almacen ? item.zona.almacen.code : "-" }}</td>
                <td>{{ item.zona ? item.zona.name : "-" }}</td>
                <td>{{ item.tipo_ubicacion ? item.tipo_ubicacion.name : "-" }}</td>
                <td>{{ item.code }}</td>
                <td>{{ item.rack }}</td>
                <td>{{ item.col }}</td>
                <td>{{ item.level }}</td>
                <td>{{ item.status ? item.status.name : "-" }}</td>
                <td>
                  <v-chip v-if="!item.seleccionable" color="red" size="x-small" class="mr-1">En el conteo #{{ item.en_conteo }}</v-chip>
                  <v-chip v-if="item.has_reserved_stock" color="orange" size="x-small" class="mr-1">Con reserva</v-chip>
                  <!-- Decision K: si entra, se cuenta entera, tambien lo del otro cliente -->
                  <v-chip v-if="item.has_other_client_stock" color="purple" size="x-small" class="mr-1">Otro cliente</v-chip>
                  <v-chip v-if="!item.has_stock" color="grey" size="x-small">Vacía</v-chip>
                </td>
              </tr>
            </template>
          </v-data-table>

          <!--
            La reserva NO excluye: se cuenta igual y queda marcada. Vale la pena decirlo aca
            porque el chip naranja invita a pensar lo contrario.
          -->
          <p class="text-caption mt-2 mb-0 text-medium-emphasis">
            Una ubicación con stock reservado <b>entra igual</b> al conteo, marcada. Lo único que queda afuera es lo que ya está en otro conteo abierto.
          </p>
          <p v-if="client != null" class="text-caption mt-1 mb-0 text-medium-emphasis">
            Se listan las ubicaciones donde <b>{{ client.name }}</b> tiene stock hoy. Las marcadas como “Otro cliente” además tienen mercadería ajena, que se va a contar igual.
          </p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="$emit('close')">Cerrar</v-btn>
          <v-btn color="success" text :disabled="selected.length == 0" @click="addSelected">Agregar ({{ selected.length }})</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { conteoService } from "@/libs/ws/conteoService";
import { ubicacionService } from "@/libs/ws/ubicacionService";
import { almacenService } from "@/libs/ws/almacenService";
import { zonaService } from "@/libs/ws/zonaService";

/**
 * Selector de ubicaciones del conteo.
 *
 * NO persiste nada: emite las Ubicacion elegidas y deja que el Modal las acumule en el step 2.
 * El alta y la baja las resuelve editCollection al guardar el documento.
 *
 * A diferencia del selector de la regla de reposicion, no pega a ubicaciones/list sino a
 * conteo/preview-ubicaciones: ese endpoint devuelve las mismas ubicaciones pero YA ordenadas
 * por recorrido fisico y marcadas con lo que el planificador necesita saber (si tienen stock,
 * si tienen reserva, y si ya estan tomadas por otro conteo abierto).
 */
export default {
  props: {
    dialog: Boolean,
    //Ids ya cargados en el conteo: no se vuelven a ofrecer
    excluded_ids: {
      type: Array,
      default: () => [],
    },
    //Almacen del conteo: fuerza el filtro asi no se mezclan ubicaciones de distintos almacenes
    almacen: {
      type: Object,
      default: null,
    },
    //Conteo propio, para que no se marque a si mismo como "ya esta en otro conteo abierto".
    //Null cuando el conteo todavia no existe (alta).
    stock_count_id: {
      type: [Number, String],
      default: null,
    },
    //Cliente del conteo: acota a las ubicaciones donde ESE cliente tiene stock hoy.
    //Es un atajo para acotar el trabajo, no una restriccion: la ubicacion no tiene dueño.
    client: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      loading_almacenes: false,
      loading_zonas: false,
      error: null,
      list: [],
      selected: [],//ids de ubicaciones tildadas en la tabla
      almacenes: [],
      zonas: [],
      states: [],
      filters: {
        zona: null,
        almacen: null,
        status: null,
        rack: null,
        col: null,
        level: null,
        code: null,
      },
      headers: [
        { title: "", key: "select", sortable: false, align: "center", width: 48 },
        { title: "Almacen", key: "almacen", sortable: false },
        { title: "Zona", key: "zona", sortable: false },
        { title: "Tipo", key: "tipo_ubicacion", sortable: false },
        { title: "Codigo", key: "code", sortable: false },
        { title: "Rack", key: "rack", sortable: false },
        { title: "Columna", key: "col", sortable: false },
        { title: "Nivel", key: "level", sortable: false },
        { title: "Estado", key: "status", sortable: false },
        { title: "", key: "marcas", sortable: false },
      ],
    };
  },
  computed: {
    available_list() {
      return this.list.filter((item) => !this.excluded_ids.includes(item.id));
    },
    /** Las tomadas por otro conteo se muestran, pero no se pueden tildar. */
    seleccionables() {
      return this.available_list.filter((item) => item.seleccionable);
    },
    all_selected() {
      return this.seleccionables.length > 0 && this.selected.length === this.seleccionables.length;
    },
    some_selected() {
      return this.selected.length > 0;
    },
  },
  watch: {
    dialog(value) {
      if (value) {
        //Cada vez que se abre el modal arranca sin tildes: sino podrian arrastrarse de una apertura anterior
        this.selected = [];
        this.error = null;

        //Si el conteo ya fijo un almacen, mando ese; sino, el que tenga guardado en localStorage
        if (this.almacen != null) {
          this.filters.almacen = this.almacen;
        } else if (this.filters.almacen == null) {
          this.filters.almacen = JSON.parse(localStorage.getItem("almacen"));
        }
        this.loadZonas();
        this.filter();
      }
    },
  },
  mounted() {
    this.loadStates();
    this.loadAlmacenes();
    if (this.almacen != null) {
      this.filters.almacen = this.almacen;
    } else {
      this.filters.almacen = JSON.parse(localStorage.getItem("almacen"));
    }
  },
  methods: {
    loadStates() {
      ubicacionService
        .getStates()
        .then((response) => {
          this.states = response.result;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    loadAlmacenes() {
      this.loading_almacenes = true;
      almacenService
        .filter()
        .then((response) => {
          this.almacenes = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        })
        .finally(() => {
          this.loading_almacenes = false;
        });
    },
    loadZonas() {
      this.loading_zonas = true;
      zonaService
        .filter({ almacen: this.filters.almacen })
        .then((response) => {
          this.zonas = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        })
        .finally(() => {
          this.loading_zonas = false;
        });
    },
    filter() {
      if (this.filters.almacen == null) {
        this.toast.error("Elegí primero el almacén.");
        return;
      }

      this.loading = true;
      this.error = null;

      //stock_count se manda para que el propio conteo no se cuente como "otro conteo abierto"
      const param = Object.assign({}, this.filters, {
        stock_count: this.stock_count_id != null ? { id: this.stock_count_id } : null,
        client: this.client != null ? { id: this.client.id } : null,
      });

      conteoService
        .preview_ubicaciones(param)
        .then((response) => {
          if (response.status) {
            this.list = response.result.list;
            this.selected = [];
          } else {
            this.list = [];
            this.error = response.msg;
          }
        })
        .catch((e) => {
          console.log("service.filter error");
          console.log(e);
          this.error = "Error al buscar ubicaciones.";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toggleAll(value) {
      //Solo las seleccionables: tildar todo no puede meter una ubicacion ya tomada
      this.selected = value ? this.seleccionables.map((item) => item.id) : [];
    },
    addSelected() {
      const items = this.available_list.filter((item) => this.selected.includes(item.id));
      this.$emit("select", items);
      this.selected = [];
    },
  },
};
</script>
